import { Component } from '@angular/core';
import { DialogComponent, DialogService } from '../../services/modal-dialogs';
import { ssApiService } from '../../services/ss-api.service';
import { SweetAlertService } from 'ng2-cli-sweetalert2';
import { GISUsageLogItem } from '../../models/domain/gis.usage.log';
import { GISPurchaseRefundRequest } from '../../models/ss-api/requests/gis.purchase.refund.request';
import { Router } from '@angular/router';

export interface IGISRefundDialogModel {
    GISUsageItem: GISUsageLogItem;
}

@Component({
    selector: 'gis-refund-dialog',
    styleUrls: ['./gis.refund.dialog.css'],
    templateUrl: './gis.refund.dialog.html'
})
export class GISRefundDialog extends DialogComponent<IGISRefundDialogModel, boolean> implements IGISRefundDialogModel {

    GISUsageItem: GISUsageLogItem;

    date: Date = new Date();
    RefundReason: string = 'Refund reason';
    amount: number = 100;

    constructor(private api: ssApiService, dialogService: DialogService, private sweetAlertService: SweetAlertService, public router: Router) {
        super(dialogService, router);
    }


    async confirm() {
        // we set dialog result as true on click on confirm button,
        // then we can get dialog result from caller code

        let request = new GISPurchaseRefundRequest();

        request.PurchaseID = this.GISUsageItem.ID;
        request.RefundReason = this.RefundReason;

        await this.sweetAlertService.swal(
            {
                title: 'Refund Credit?',
                text: 'Are you sure you want to refund this GIS Credit?',
                type: 'warning',
                showCancelButton: true,
                showConfirmButton: true,
                confirmButtonText: 'Yes!',
                cancelButtonText: 'Cancel',
                allowOutsideClick: false,
                showLoaderOnConfirm: true,
                preConfirm: () => {
                    return this.api.GISSinglePurchaseRefund(request).toPromise();
                }
            }).then(async (response: any) => {
                this.result = true;
                this.close();
                this.sweetAlertService.swal(
                    {
                        title: 'Success',
                        text: 'GIS Purchase Refunded',
                        type: 'success',
                        showCancelButton: false,
                        showConfirmButton: false,
                        timer: 1500
                    }).then((response: any) => {
                    }, (dismiss) => {
                        return;
                    }); // keep this line to prevent promise error;
            }, (dismiss) => {
                return;
            }).catch(error => {
                this.sweetAlertService.swal({
                    title: 'Error',
                    text: error.message,
                    type: 'error',
                    showCancelButton: false,
                    showConfirmButton: true,
                    confirmButtonText: 'OK',
                })
                    .then((response: any) => {
                        this.result = false;
                        this.close();
                    }, (dismiss) => {
                        return;
                    }); // keep this line to prevent promise error;
            });

    }

}
